import { names, requestSuccessFailure } from 'utilities/constants';

export const SUPERVISOR_PREFIX = 'SUPERVISOR_DATA';

export const DIVISION_PREFIX = 'DIVISION_DATA';

export const DIVISION_LOCATION_DATA_PREFIX = 'DIVISION_LOCATION_DATA';

export const LOCATION_COMPETENCE_DATA_PREFIX = 'LOCATION_COMPETENCE_DATA';

const supervisorConstants = {
    ...names('OPEN_LOCATION_DIALOG', 'CLOSE_LOCATION_DIALOG', 'MARK_PENDING_COMPETENCE_AS_COMPLETE'),
    ...requestSuccessFailure(DIVISION_PREFIX),
    ...requestSuccessFailure(SUPERVISOR_PREFIX),
    ...requestSuccessFailure(DIVISION_LOCATION_DATA_PREFIX),
    ...requestSuccessFailure(LOCATION_COMPETENCE_DATA_PREFIX),
}

export default supervisorConstants;